import json from "../../informationArchitecture.json";
import React, { ReactElement } from "react";
import { DataTable, DataTableHeaderRow, DataTableColumnHeaderCell, DataTableContent,DataTableBody, DataTableRow, DataTableCell } from "@episerver/ui-framework";

const types = [
    "workType",
    "workSubType",
    "workItem",
    "workSubItem",
    "workItemAction",
    "workItemAspect"
];

const convertFromCamelCase = (str: string): string => {
    return str.replace(/([A-Z])/g, " $1")
        // uppercase the first character
        .replace(/^./, (str) => str.toUpperCase());
};

const createHeaders = (maxLength = types.length): ReactElement[] => {
    const headerList: ReactElement[] = [];
    types.forEach((t, index) => {
        if (index >= maxLength) {
            return;
        }
        headerList.push(<DataTableColumnHeaderCell>{convertFromCamelCase(t)}</DataTableColumnHeaderCell>);
    });

    return headerList;
};

let rowList: ReactElement[] = [];
let row: ReactElement[] = [];
let previousColumnNumber = 0;

const pushRow = (maxLength: number): void => {
    // Fill in any missing empty columns at the end of the table
    if (rowList.length > 0) {
        for (let i = previousColumnNumber; i < maxLength - 1; i++) {
            row.push(<DataTableCell><></></DataTableCell>);
        }
    }
    rowList.push(<DataTableRow rowId={""}>{row}</DataTableRow>);
    row = [];
};

const addCellToRow = (name: string, treeLevel: number, columnNumber: number, maxLength = types.length): any => {
    // workItemAspects are just arrays, so there's no key to match to get the columnNumber
    if (columnNumber === 0 && treeLevel > 1) {
        columnNumber = maxLength - 1;
    }

    // Push the current row and start a new one
    if (columnNumber <= previousColumnNumber) {
        pushRow(maxLength);
    }

    for (let i = 0; i < maxLength; i++) {
        if (i === columnNumber) {
            row.push(<DataTableCell>{name}</DataTableCell>);
            previousColumnNumber = columnNumber;
        } else if (row.length < columnNumber && i < columnNumber) { // Fill in missing empty columns before the current item
            row.push(<DataTableCell><></></DataTableCell>);
        }
    }
};

const traverse = (x: any, maxLength: number, level = 0, columnNumber = 0): void => {
    if (Array.isArray(x)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        traverseArray(x, maxLength, level);
    } else if ((typeof x === "object") && (x !== null)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        traverseObject(x, maxLength, level);
    } else {
        addCellToRow(x, level, columnNumber, maxLength);
    }
};

const traverseArray = (arr: any[], maxLength: number, level: number): void => {
    arr.forEach((x) => {
        traverse(x, maxLength, level + 1);
    });
};

const traverseObject = (obj: any, maxLength: number, level: number): void => {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            traverse(obj[key], maxLength, level, types.indexOf(key));
        }
    }
};

export const createTable = (productName: string, actionLinks = false): ReactElement => {
    const product = json.find(item => item.product === productName);

    rowList = [];
    row = [];

    let maxLength = types.length;
    previousColumnNumber = 0;
    if (actionLinks) {
        maxLength = 2;
        traverse(product && product.actionLinks.workTypes, maxLength);
    } else {
        traverse(product && product.workTypes, maxLength);
    }

    // push the final row
    pushRow(maxLength);
    return (
        <DataTable>
            <DataTableContent>
                <DataTableHeaderRow>
                    {createHeaders(maxLength)}
                </DataTableHeaderRow>
                <DataTableBody>
                    {rowList}
                </DataTableBody>
            </DataTableContent>
        </DataTable>
    );
};
